import React from "react";

const MilestoneProgress = ({ milestones }) => {
  // Find the index of the first incomplete milestone
  const firstIncompleteIndex = milestones.findIndex(
    (milestone) => !milestone.isComplete
  );

  // For logged-in users, check if all previous milestones are complete
  const isMilestoneAccessible = (index) => {
    if (index === 0) return true;
    return milestones.slice(0, index).every((m) => m.isComplete);
  };

  // Calculate the total number of segments
  const totalSegments = milestones.length - 1;
  // Calculate the width/height percentage for each segment
  const segmentSize = 100 / totalSegments;

  return (
    <div className="w-full max-w-4xl mx-auto p-4">
      <div className="relative">
        {/* Progress lines between milestones */}
        <div className="absolute left-4 top-0 h-[calc(100%-32px)] w-1">
          {milestones.slice(0, -1).map((_, index) => {
            const isCompleted = index < firstIncompleteIndex;
            const isAccessible = isMilestoneAccessible(index);

            return (
              <div
                key={`line-${index}`}
                className="absolute w-full transition-all duration-300"
                style={{
                  top: `${index * segmentSize}%`,
                  height: `${segmentSize}%`,
                  backgroundColor:
                    isAccessible && isCompleted ? "#242424" : "#C4C1BB",
                }}
              />
            );
          })}
        </div>

        {/* Milestone dots and labels */}
        <div className="flex flex-col justify-between relative">
          {milestones.map((milestone, index) => {
            const isAccessible = isMilestoneAccessible(index);
            const isCompleted = milestone.isComplete;
            const isCurrent = index === firstIncompleteIndex;

            return (
              <div
                key={milestone.key}
                className="flex flex-row items-center mb-8 last:mb-0"
              >
                <div className="flex flex-row items-center">
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center ${
                      isAccessible
                        ? isCompleted
                          ? "bg-brand-charcoal"
                          : isCurrent
                          ? "bg-white border-2 border-brand-charcoal"
                          : "bg-[#C4C1BB]"
                        : "bg-[#C4C1BB]"
                    }`}
                  >
                    {isAccessible && isCompleted ? (
                      <svg
                        className="w-5 h-5 text-brand-cream"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    ) : (
                      <span
                        className={`font-bold ${
                          isAccessible && isCurrent
                            ? "text-brand-charcoal"
                            : "text-white"
                        }`}
                      >
                        {index + 1}
                      </span>
                    )}
                  </div>
                  <span
                    className={`ml-4 text-sm ${
                      isAccessible && isCurrent
                        ? "font-display font-bold text-brand-charcoal"
                        : "font-medium"
                    }`}
                    style={
                      isAccessible && isCurrent
                        ? undefined
                        : {
                            color: isAccessible && isCompleted
                              ? "#242424"
                              : "#B8B5AF",
                          }
                    }
                  >
                    {isCompleted
                      ? milestone.label
                      : milestone.inProgressLabel || milestone.label}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MilestoneProgress;
